import type { CodeLookup } from '@runkr/schema'

/** The game server's HTTP base for a `ws(s)://` server URL. */
export function httpBase(serverUrl: string): string {
  return serverUrl.replace(/^ws/, 'http').replace(/\/$/, '')
}

/**
 * `GET /code/<CODE>` (D-025, D-040): the room and its kind, or null for an unknown or expired
 * code. A server before T2.7 sends no `kind`: its codes are private races. Throws on network
 * errors and other statuses (429 included).
 */
export async function lookupCode(serverUrl: string, code: string): Promise<CodeLookup | null> {
  const res = await fetch(`${httpBase(serverUrl)}/code/${encodeURIComponent(code)}`)
  if (res.status === 404) return null
  if (!res.ok) throw new Error(`code lookup failed (${res.status})`)
  const body = (await res.json()) as { roomId?: unknown; kind?: unknown }
  if (typeof body.roomId !== 'string') throw new Error('code lookup: bad response')
  return { roomId: body.roomId, kind: body.kind === 'party' ? 'party' : 'race' }
}
